var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.727 29.405l-7.73-7.827a14.28 14.28 0 001.915-7.099C28.912 6.497 22.422 0 14.456 0 6.49 0 0 6.497 0 14.48c0 7.982 6.49 14.479 14.456 14.479 2.543 0 5.058-.702 7.3-2.041l7.693 7.8c.173.173.42.282.666.282.246 0 .492-.1.665-.282l3.947-3.992a.935.935 0 000-1.32zM14.454 5.64c4.867 0 8.823 3.963 8.823 8.838 0 4.876-3.956 8.84-8.823 8.84-4.867 0-8.823-3.965-8.823-8.84S9.587 5.64 14.454 5.64z",
    fill: "#92A0C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default "/_next/static/images/957405c8e2d4957564f64fceb0c4b841.svg";
export { ForwardRef as ReactComponent };